import React from 'react';

import values from '../../values';

import { useTranslation } from 'react-i18next';
import {
  BreadCrumb,
  CustomView,
  ResponsiveView,
  TableHeader,
  TableLoading,
} from '../../components';

import AcademicYearComponents from './Components';

type Props = {
  rqData: any;
};

const AcademicYearScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  const { t } = useTranslation();

  // ? No pagination here: the year list is one row per school year, and the endpoint returns them all rather than
  // ? a page. A pagination control would have nothing to page through.
  return (
    <ResponsiveView.Container id="academic-year-screen-wrapper">
      <CustomView.Row className="table-options-wrapper">
        <CustomView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </CustomView.Column>
        <CustomView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          <AcademicYearComponents.Create />
        </CustomView.Column>
      </CustomView.Row>

      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.ACADEMIC_YEAR_TABLE.map((item: string) => t(item))} />
            {props.rqData?.status === 'loading'
              ? <TableLoading />
              : <AcademicYearComponents.Body data={props.rqData} />}
          </table>
        </div>
      </ResponsiveView.Container>

      <AcademicYearComponents.Update />
      <AcademicYearComponents.Delete />
    </ResponsiveView.Container>
  );
};

export default AcademicYearScreen;
